import { supabase } from '@/lib/supabase';
import {
  ProjectKpiMetrics,
  ProjectKpiWithMetrics,
  ProjectType,
} from '@/shared/types/api';

export const getProjectKpis = async (
  projectId: number,
  projectType: ProjectType,
): Promise<ProjectKpiWithMetrics[]> => {
  if (projectType === 'project') {
    const { data, error } = await supabase
      .from('project_kpis')
      .select('*, metrics:kpi_metrics(*)')
      .eq('project_id', projectId)
      .order('created_at', { ascending: false });

    if (error) {
      throw error;
    }

    const projectKpis = data.map((kpi) => {
      const metrics = kpi.metrics as unknown as ProjectKpiMetrics;
      return {
        ...kpi,
        metrics,
      };
    });

    return projectKpis as ProjectKpiWithMetrics[];
  } else if (projectType === 'subproject_client') {
    const { data, error } = await supabase.rpc('get_subproject_kpis', {
      p_project_id: projectId,
    });

    if (error) {
      throw error;
    }

    return data.map((kpi) => {
      const metrics = kpi.metrics as unknown as ProjectKpiMetrics;
      return {
        ...kpi.project_kpis,
        max_value: kpi.budget,
        metrics,
        kpi_budget_id: kpi.budget_id,
      };
    });
  } else if (projectType === 'subproject_contractor') {
    const { data: assignedKpisData, error: assignedKpisError } =
      await supabase.rpc('get_subproject_kpis', {
        p_project_id: projectId,
      });

    if (assignedKpisError) {
      throw assignedKpisError;
    }

    const assignedKpis: ProjectKpiWithMetrics[] = assignedKpisData.map(
      (kpi) => {
        const metrics = kpi.metrics as unknown as ProjectKpiMetrics;
        return {
          ...kpi.project_kpis,
          max_value: kpi.budget,
          metrics,
          kpi_budget_id: kpi.budget_id,
        };
      },
    );

    const { data: ownKpisData, error: ownKpisError } = await supabase
      .from('project_kpis')
      .select('*, metrics:kpi_metrics(*)')
      .eq('project_id', projectId)
      .order('created_at', { ascending: false });

    if (ownKpisError) {
      throw ownKpisError;
    }

    const ownKpis: ProjectKpiWithMetrics[] = ownKpisData.map((kpi) => {
      const metrics = kpi.metrics as unknown as ProjectKpiMetrics;
      return {
        ...kpi,
        metrics,
      };
    });

    return [...assignedKpis, ...ownKpis];
  }

  return [];
};
